@if (liveEntries) {
  <section class="tournament-section-container">
    @if (sorted_tabs.length > 1) {
      <app-carousel [config]="splideConfig" class="tabs">
        @for (tab of sorted_tabs; track tab) {
          <app-slide class="tab" [ngClass]="tab === selected_filter ? 'selected_filter' : ''" (click)="filter_entries(tab)">
            {{ getAppString(filter_tabs[tab]) }}
          </app-slide>
        }
      </app-carousel>
    }
    @if (live_entries.length > 0 && !header_banner) {
      <div class="section-title">{{ getAppString(header) }}</div>
    }
    @if (header_banner) {
      <app-sponsor-banner [sponsor_key]="'t1-tournaments-presenting'" [aspect_ratio]="'9/1'"></app-sponsor-banner>
    }
    <div class="tournaments scroll-section">
      <div class="live-section">
        @for (item of live_entries; track item) {
          <app-scheduled-entry (click)="routeLink(item)" [entry]="item" [attr.data-schedule-entry-id]="item?.id"></app-scheduled-entry>
        }
      </div>
    </div>
  </section>
}
